import { iconSubmitButton } from 'globals/assets';
import {
  appBackgroundColor,
  errorColor,
  chatInputDropShadow,
  appButtonFontColor,
  chatHistoryBGColor,
  grayText,
} from 'globals/colors';
import { transitionDuration } from 'globals/styles';

const styles = {
  wrapper: {
    padding: '5px 42px 5px 10px',
    position: 'relative',
    background: `${appBackgroundColor}`,
    border: '1px solid transparent',
    boxShadow: `0 -8px 15px 0 ${chatInputDropShadow}`,
  },
  hasError: {
    borderTop: `1px solid ${errorColor}`,
    borderBottom: `1px solid ${errorColor}`,
  },
  enter: {
    position: 'absolute',
    right: '10px',
    top: '12px',
    cursor: 'pointer',
    height: '22px',
    width: '22px',
    background: appButtonFontColor,
    lineHeight: '22px',
    textAlign: 'center',
    borderRadius: '50%',
    transition: `all ${transitionDuration}`,
  },
  enterIcon: {
    display: 'inline-block',
    backgroundImage: `url("${iconSubmitButton}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '10px',
    height: '10px',
    width: '10px',
  },
  wrapperTeam: {
    padding: '5px 10px',
    position: 'relative',
    background: `${chatHistoryBGColor}`,
    boxShadow: `0 -8px 15px 0 ${chatInputDropShadow}`,
  },
  wrapperDisabled: {
    padding: '10px',
    background: `${chatHistoryBGColor}`,
    boxShadow: `0 -8px 15px 0 ${chatInputDropShadow}`,
    textAlign: 'center',
  },
  disabledText: {
    color: grayText,
    fontWeight: '500',
    fontSize: '13px',
  },
  wrapperOptions: {
    padding: '5px 10px',
    position: 'relative',
    background: `${chatHistoryBGColor}`,
    boxShadow: `0 -8px 15px 0 ${chatInputDropShadow}`,
  },
};

export default styles;
